module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "scale-svg",
    attrs: {
      "width": "3082px",
      "height": "570px",
      "viewBox": "0 0 3082 570"
    }
  }, [_c('g', {
    attrs: {
      "id": "gym_door"
    }
  }, [_c('rect', {
    attrs: {
      "id": "Rectangle-6",
      "fill": "#F7AE5C",
      "x": "1888",
      "y": "120",
      "width": "274",
      "height": "450"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Rectangle-6",
      "fill": "#FCBE78",
      "x": "1918",
      "y": "150",
      "width": "214",
      "height": "240"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "Rectangle-6",
      "fill": "#F9C993",
      "points": "2082 150 2132 150 1968 390 1918 390"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "Rectangle-6",
      "fill": "#F9C993",
      "points": "2132 203.663654 2008 390 1988 390 2132 179"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60fb77d1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/module_6/svg/gymDoor.vue
// module id = 998
// module chunks = 1